import React from 'react';
import {
  FormLabel,
  FormHelperText,
  Button,
  ButtonGroup,
  makeStyles,
  Tooltip,
} from '@material-ui/core';
import PropTypes from 'prop-types';

import styles from './styles';

export default function FormButtonGroup(props) {
  const useStyles = makeStyles(styles);
  const classes = useStyles();
  const {
    data = [],
    helperText,
    handleChange,
    error = false,
    id,
    value,
    disabled = false,
    buttonGroupFieldClass,
    filedContainerClass,
  } = props;

  const isSelected = (uuid) => (uuid === null && value === undefined) || (uuid === value);

  return (
    <div
      data-apim-test={id}
      className={filedContainerClass || classes.fieldContainer}
      id={id}
    >
      <FormLabel className={classes.formLabel}>
        {props.name}
      </FormLabel>
      <ButtonGroup
        className={buttonGroupFieldClass || classes.buttonGroupField}
        disabled={disabled}
      >
        {data && data.map(({ uuid, name, tooltip }) =>
          <Tooltip
            arrow
            key={uuid}
            open={tooltip ? undefined : false}
            title={tooltip}
          >
            <Button
              data-apim-test={isSelected(uuid) && 'button-selected'}
              key={uuid}
              data-value={uuid}
              variant={isSelected(uuid) ? 'contained' : 'outlined'}
              color="secondary"
              onClick={(e) => {
                handleChange(e.currentTarget.dataset.value);
              }}
              classes={{
                contained: classes.contained,
              }}
            >
              {name}
            </Button>
          </Tooltip>,
        )}
      </ButtonGroup>
      {helperText && <FormHelperText
        error={error}
      >
        {helperText}
      </FormHelperText>}
    </div>
  );
}

FormButtonGroup.propTypes = {
  buttonGroupFieldClass: PropTypes.string,
  name: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.shape({})),
  helperText: PropTypes.string,
  handleChange: PropTypes.func,
  error: PropTypes.bool,
  id: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  filedContainerClass: PropTypes.string,
};
